import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot, orderBy, getDocs, limit } from 'firebase/firestore';
import { startOfDay, endOfDay } from 'date-fns';
import { db } from '../../../firebase';

const useDashboardData = () => {
    const [activeServices, setActiveServices] = useState([]);
    const [dueServices, setDueServices] = useState([]);
    const [debtors, setDebtors] = useState([]);
    const [allTodaysPayments, setAllTodaysPayments] = useState([]);
    // const [todaysAppointments, setTodaysAppointments] = useState([]); // Removed as per request
    const [upcomingPayments, setUpcomingPayments] = useState([]); // Replaces todaysAppointments
    const [todaysSleepAppointments, setTodaysSleepAppointments] = useState([]);
    const [todaysServices, setTodaysServices] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubActive = onSnapshot(
            query(collection(db, "serviceRecords"), where("durum", "in", ["Beklemede", "İşlemde", "Tamamlandı"]), orderBy("teslimTarihi", "asc")),
            (snapshot) => setActiveServices(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })))
        );

        const unsubDue = onSnapshot(
            query(collection(db, "serviceRecords"), where("kalanTutar", ">", 0), orderBy("kalanTutar", "desc")),
            (snapshot) => setDueServices(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })))
        );

        // Borçlu müşterileri çek
        const unsubDebtors = onSnapshot(
            query(collection(db, "customers"), where("bakiye", ">", 0), orderBy("bakiye", "desc"), limit(20)),
            (snapshot) => setDebtors(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })))
        );

        return () => { unsubActive(); unsubDue(); unsubDebtors(); };
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const todayStart = startOfDay(new Date());
                const todayEnd = endOfDay(new Date());

                // Payments - SADECE TRANSACTIONS KULLANILIYOR
                const transactionsQuery = query(collection(db, 'transactions'), where('timestamp', '>=', todayStart), where('timestamp', '<=', todayEnd), where('type', '==', 'tahsilat'));

                let todaysTransactions = [];
                try {
                    const transactionsSnapshot = await getDocs(transactionsQuery);
                    todaysTransactions = transactionsSnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));

                    const transactionsFormatted = todaysTransactions.map(t => ({
                        customerName: t.customerName,
                        description: t.description,
                        amount: t.amount || 0,
                        date: t.timestamp
                    }));
                    transactionsFormatted.sort((a, b) => (b.date?.toMillis() || 0) - (a.date?.toMillis() || 0));
                    setAllTodaysPayments(transactionsFormatted);
                } catch (err) {
                    console.error("Tahsilatlar çekilemedi:", err);
                }

                // Scheduled Payments (Yaklaşan Ödemeler - Randevulardan)
                try {
                    const scheduledQuery = query(
                        collection(db, 'appointments'),
                        where('ilgilenilenHizmet', '==', 'Ödeme'),
                        where('randevuTarihi', '>=', todayStart),
                        where('randevuTarihi', '<=', todayEnd), // İsteğe bağlı: Sadece bugünü mü yoksa ileriye dönük mü? "Yaklaşan" dediği için limitli kalsın ama sort önemli.
                        // NOT: Compound query (ilgilenilenHizmet + randevuTarihi) index gerektirir. Eğer index yoksa bu patlar.
                        // Geçici çözüm: Sadece tarih ile çekip client-side filtreleme yapalım (veri azsa).
                        // Veya index oluşturana kadar try-catch ile koruyalım.
                        orderBy('randevuTarihi', 'asc'),
                        limit(10)
                    );
                    const scheduledSnapshot = await getDocs(scheduledQuery);
                    setUpcomingPayments(scheduledSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
                } catch (err) {
                    console.error("Yaklaşan ödeme randevuları çekilemedi (Index gerekebilir):", err);
                    // Fallback: Client side filtering if possible, or just empty
                }

                // Daily Summary Diğer Veriler
                try {
                    const sleepQuery = query(collection(db, 'sleepAppointments'), where('randevuTarihi', '>=', todayStart), where('randevuTarihi', '<=', todayEnd));
                    const servicesQuery = query(collection(db, 'serviceRecords'), where('olusturmaTarihi', '>=', todayStart), where('olusturmaTarihi', '<=', todayEnd));

                    const [sleepSnap, servicesSnap] = await Promise.all([
                        getDocs(sleepQuery),
                        getDocs(servicesQuery)
                    ]);

                    setTodaysSleepAppointments(sleepSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
                    setTodaysServices(servicesSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
                } catch (err) {
                    console.error("Özet verileri çekilemedi:", err);
                }

            } catch (error) {
                console.error("Dashboard verisi çekilirken hata:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return {
        activeServices,
        dueServices,
        debtors,
        allTodaysPayments,
        upcomingPayments, // Changed from todaysAppointments
        todaysSleepAppointments,
        todaysServices,
        loading
    };
};

export default useDashboardData;
